import { useCallback, FC } from "react";
import styled from "styled-components";

import Badge from "@ingka/badge";
import { space250 } from "@ingka/variables/design-tokens";
import { MenuItem } from "@ingka/list-box";

import { Application, Market } from "../../store";
import { PillDropdown } from "../Dropdown";

const StyledBadge = styled(Badge)`
	min-height: ${space250};
	min-width: ${space250};
`;

interface ApplicationLayoutProps {
	loading: boolean;
	applicationsData?: Application[];
	activeApplication: Application | null;
	setActiveApplication: (data: Application | null) => void;
	setActiveMarket: (data: Market | null) => void;
	setselectedMarkets: (markets: Market[]) => void;
	setMultipleMarketFlag: (flag: boolean) => void;
	setActiveApp: (appId: string) => void;
}

const Layout: FC<ApplicationLayoutProps> = ({
	loading,
	applicationsData = [],
	activeApplication,
	setActiveApplication,
	setActiveMarket,
	setselectedMarkets,
	setMultipleMarketFlag,
	setActiveApp,
}) => {
	const handleApplicationChange = useCallback(
		(appId: string) => {
			const selectedApp = applicationsData.find((app) => app?.id === appId) ?? applicationsData[0];

			if (!selectedApp) {
				return;
			}

			setActiveApp(selectedApp.id);
			setActiveApplication(selectedApp);

			setActiveMarket(null);
			setselectedMarkets([]);
			setMultipleMarketFlag(false);
		},
		[applicationsData, setActiveApp, setActiveApplication, setActiveMarket, setselectedMarkets, setMultipleMarketFlag]
	);

	const renderMenuItem = useCallback((application: Application) => {
		return application && <MenuItem key={application.id} id={application.id} title={application.name} />;
	}, []);

	if (!loading && applicationsData.length === 0) {
		return null;
	}

	const hasMultipleApps = applicationsData.length > 1;

	return (
		<>
			{hasMultipleApps ? (
				<PillDropdown
					id="applications-dropdown"
					value={activeApplication?.id}
					label={activeApplication?.name}
					onChange={handleApplicationChange}
					ariaLabel="Application"
				>
					{applicationsData.map(renderMenuItem)}
				</PillDropdown>
			) : (
				<StyledBadge label={activeApplication?.name ?? ""} />
			)}
		</>
	);
};

export default Layout;
